module.exports = __webpack_public_path__ + "static/media/camps.4c5fc120.png";